<div class="timer">

  <div class="timer-clock">
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clip-path="url(#clip0_44956_48358)">
        <path
          d="M12.7134 0.00488281C13.2174 0.0561913 13.6107 0.482422 13.6108 1C13.6108 1.51767 13.2175 1.94378 12.7134 1.99512L12.6108 2H10.9028C10.9054 2.02945 10.9077 2.05971 10.9077 2.08984V3.7002C10.9077 3.74766 10.9024 3.79414 10.896 3.83984C12.2664 3.98951 13.5337 4.48072 14.6118 5.22656C14.6381 5.19243 14.6675 5.16018 14.6987 5.12891L15.8374 3.99023L15.9136 3.92188C16.3063 3.60144 16.8853 3.62421 17.2515 3.99023C17.617 4.35627 17.6407 4.93552 17.3208 5.32812L17.2515 5.4043L16.1128 6.54297C16.1087 6.54705 16.1033 6.54971 16.0991 6.55371C17.3515 7.9806 18.1128 9.84975 18.1128 11.8975C18.1127 16.3743 14.4832 20.0037 10.0063 20.0039C5.52936 20.0039 1.90003 16.3744 1.8999 11.8975C1.8999 7.78822 4.95723 4.39439 8.92139 3.86426C8.91254 3.81085 8.90774 3.75611 8.90771 3.7002V2.08984C8.90771 2.05972 8.90901 2.02945 8.91162 2H7.3999C6.84762 2 6.3999 1.55228 6.3999 1C6.40003 0.447827 6.8477 0 7.3999 0H12.6108L12.7134 0.00488281ZM10.0063 5.79102C6.63385 5.79102 3.89991 8.52497 3.8999 11.8975C3.90003 15.2698 6.63393 18.0039 10.0063 18.0039C13.3786 18.0037 16.1127 15.2697 16.1128 11.8975C16.1128 8.5251 13.3787 5.79123 10.0063 5.79102ZM9.90771 7.3916C10.4598 7.39183 10.9077 7.83946 10.9077 8.3916V11.8027L10.9028 11.9053C10.8513 12.409 10.425 12.8025 9.90771 12.8027C9.39024 12.8027 8.9642 12.4091 8.9126 11.9053L8.90771 11.8027V8.3916C8.90771 7.83932 9.35543 7.3916 9.90771 7.3916Z"
          fill="#079BD1" />
      </g>
      <defs>
        <clipPath id="clip0_44956_48358">
          <rect width="20" height="20" fill="white" />
        </clipPath>
      </defs>
    </svg>
  </div>

  <ng-container *ngIf="timer.timers.total as total">
    <p *ngIf="!total.done; else done" class="timer-title">
      <span class="timer-title-time">
        {{ total.stopWatch$ | async }}
      </span>
      <span>
        {{ 'result.of' | translate }}
      </span>
      <span>
        {{ total.max | toMinutes | date:'m' }}
      </span>
      <span>
        {{ 'result.min' | translate }}
      </span>
    </p>
    <ng-template #done>
      <p *ngIf="timer.timers.limit as limit" class="timer-title done">
        <span class="timer-title-time">
          {{ limit.stopWatch$ | async }}
        </span>
        <span>
          {{ 'result.of' | translate }}
        </span>
        <span>
          {{ limit.max | toMinutes | date:'m' }}
        </span>
        <span>
          {{ 'result.min' | translate }}
        </span>
      </p>
    </ng-template>
  </ng-container>

  <ng-container *ngIf="timer.timers.total.done as done">
    <div class="timer-done">
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M11.9962 2.26472C11.9759 2.04868 11.876 1.85376 11.7145 1.71569L10.5088 0.684218C10.1763 0.399955 9.68389 0.450311 9.41075 0.796299L4.3405 7.21819L2.30366 5.40135C1.97667 5.1114 1.48346 5.14958 1.20329 5.48988L0.187997 6.72358C0.0522071 6.88764 -0.013347 7.09799 0.00226094 7.31403C0.0178689 7.53007 0.114639 7.72743 0.272279 7.86875L4.12433 11.3043C4.26714 11.4318 4.44507 11.5 4.63081 11.5C4.65422 11.5 4.67685 11.4992 4.70026 11.4968C4.91097 11.4773 5.10061 11.3733 5.23484 11.2036L11.823 2.85923C11.9548 2.69192 12.0165 2.47994 11.9962 2.26472Z"
          fill="#46C783" />
      </svg>
    </div>
  </ng-container>

</div>